import { useIntl } from "react-intl";
import ToGo from "../../components/QC/ToGo";
import Controlled from "../../components/QC/Controlled";
import Summary from "../../components/QC/Summary";
import ReturnFileHeader from "../../components/ui/ReturnFileHeader";
import { useParams } from "react-router-dom";
import axios from "../../api/axiosClient";
import { useState, useEffect, useRef, useCallback } from "react";
import { useSelector } from "react-redux";
import { handleError, errorToast } from "../../services/serviceBase";
import { useLoading } from "../../components/LoadingContext";
import {
  Typography,
  IconButton,
  Grid,
  Button,
  DialogContentText,
  DialogContent,
  Dialog,
  DialogActions,
  DialogTitle,
  Box,
} from "@mui/material";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import AssignmentTurnedInOutlinedIcon from "@mui/icons-material/AssignmentTurnedInOutlined";
import SearchIcon from "@mui/icons-material/Search";
import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
import { Link } from "react-router-dom";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import ReturnFileActions from "../../components/ui/ReturnFileActions";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import BarcodeIcon from "../../components/ui/BarcodeIcon";
import CustomInput from "../../components/ui/CustomInput";
import { useDispatch } from "react-redux";
import { setIsEdit, setBackFromDefect, setSelectedIdOutcome } from "../../redux/qcSlice";
import { setSearch } from "../../redux/searchSlice";
import { setDoSearch } from "../../redux/searchSlice";
import useStreamState from "../../components/CustomHooks/useStreamState";

const QCDetail = () => {
  const intl = useIntl();
  const navigate = useNavigate();

  const user = useSelector((state) => state.auth.user);
  const isMagiUser = user?.profile?.default_role == "MAGI";
  const withStealthFlow = useSelector((state) => state.common.withStealthFlow);

  const params = useParams();
  const { idReturnFileHead } = params;
  const { setLoading } = useLoading();
  const [details, setDetails] = useState([]);
  const [render, setRender] = useState(false);
  const [detailsHeader, setDetailsHeader] = useState(null);
  const [detailsColumns, setDetailsColumns] = useState([]);
  const [detailsRows, setDetailsRows] = useState([]);
  const [groupedDetailsRows, setGroupedDetailsRows] = useState([]);
  const [outcomes, setOutcomes] = useState([]);
  const [showToGo, setShowToGo] = useState(true);
  const [showControlled, setShowControlled] = useState(false);
  const [showSummary, setShowSummary] = useState(false);
  const [tabValue, setTabValue] = useState("togo");
  const [toGoDetailsRow, setToGoDetailsRow] = useState([]);
  const [outcomesData, setOutcomesData] = useState([]);
  const [checkedData, setCheckedData] = useState([]);
  const [notCheckedData, setNotCheckedData] = useState([]);
  const [allData, setAllData] = useState([]);

  const showTabValueRef = useRef(tabValue);

  const [openEndOfCheck, setOpenEndOfCheck] = useState(false);
  const [allChecked, setAllChecked] = useState(false);
  const [openConfirmEndOfCheck, setOpenConfirmEndOfCheck] = useState(false);
  const [idReconditionTypeOfReturnFile, setIdReconditionTypeOfReturnFile] =
    useState(-1);

  const [state, setState] = useState(null);

  const dispatch = useDispatch();

  const [tableHeigth, setTableHeigth] = useState(500);
  const resizeTable = () => {
    var headerHeight = document.querySelector("#header")?.clientHeight;
    var actionsHeight = document.querySelector("#actions")?.clientHeight;
    var fireArticleBarcodeHeight = document.querySelector(
      "#fireArticleBarcode"
    )?.clientHeight;
    var tabsHeigth = document.querySelector("#tabs")?.clientHeight;
    var qcButtonsHeigth = document.querySelector("#QCButtons")?.clientHeight;
    var pageHeight = window.innerHeight;
    var tableHeight =
      pageHeight -
      headerHeight -
      actionsHeight -
      fireArticleBarcodeHeight -
      tabsHeigth -
      qcButtonsHeigth -
      120;
    setTableHeigth(tableHeight);
  };

  useEffect(() => {
    window.addEventListener("resize", resizeTable);
    getDetails();
    dispatch(
      setBackFromDefect({
        backFromDefect: false,
      })
    );
    return () => {
      window.removeEventListener("resize", resizeTable);
    };
  }, []);

  useStreamState({ detailsHeader, idReturnFileHead, user, setState, intl });

  const handleClickEndOfCheck = () => {
    if (toGoDetailsRow.length == 0) {
      setOpenEndOfCheck(false);
      setOpenConfirmEndOfCheck(true);
    } else {
      setOpenEndOfCheck(true);
      setOpenConfirmEndOfCheck(false);
    }
  };

  const handleRedirect = (endOfCheckType) => {
    if (endOfCheckType == "intermediate") {
      window.location.reload();
    } else {
      navigate(`${process.env.PUBLIC_URL}/RADetail/${idReturnFileHead}`);
    }
  };

  const handleCloseEndOfCheck = (e, endOfCheckType) => {
    e.preventDefault();
    setLoading(true);
    if (endOfCheckType == "intermediate" || endOfCheckType == "definitive") {
      var url = "/returnfiles/" + idReturnFileHead + "/endofcheck";

      var data = {
        isIntermediate: endOfCheckType == "intermediate",
      };

      axios
        .post(url, data)
        .then((response) => {
          setLoading(false);
          if (allChecked) {
            setOpenConfirmEndOfCheck(false);
          } else {
            setOpenEndOfCheck(false);
          }

          handleRedirect(endOfCheckType);
        })
        .catch((error) => {
          setLoading(false);
          handleError(error, intl);
        });
    } else {
      if (allChecked) {
        setOpenConfirmEndOfCheck(false);
      } else {
        setOpenEndOfCheck(false);
      }
    }
  };

  useEffect(() => {
    getDetailsHeaderColumns();
  }, [detailsRows, groupedDetailsRows]);

  useEffect(() => {
    if (
      idReconditionTypeOfReturnFile == null ||
      idReconditionTypeOfReturnFile == 0
    ) {
      toast.error(intl.formatMessage({ id: "QC.MissingReconditionType" }));
    } else if (idReconditionTypeOfReturnFile != -1) {
      setIdReconditionTypeOfReturnFile(idReconditionTypeOfReturnFile);
    }
  }, [idReconditionTypeOfReturnFile]);

  const getDetails = () => {
    setLoading(true);
    axios
      .get("/returnfiles/" + idReturnFileHead)
      .then((response) => {
        setLoading(false);
        setDetails(response.data);
        setDetailsHeader(response.data.returnFileHeadInfo);
        setIdReconditionTypeOfReturnFile(
          response.data.returnFileHeadInfo?.idReconditionType
        );
        setState({
          rfState: response.data.returnFileHeadInfo.rfState,
          rfStateCode: response.data.returnFileHeadInfo.rfStateCode,
        });

        let initialRowsData = response.data.returnFileRowInfoList.map((x) => {
          return { ...x };
        });

        response.data.returnFileRowInfoList.forEach((element) => {
          element.qcActionValid =
            response.data.returnFileHeadInfo?.idReconditionType != 0;
        });

        if (response.data.outcomes != [] && response.data.outcomes.length > 0) {
          setDetailsRows(response.data.returnFileRowInfoList);
          let rowsDataForToGo = response.data.returnFileRowInfoList;
          let rowsDataForToControlled = response.data.returnFileRowInfoList;
          setOutcomes(response.data.outcomes);

          let toGoGroupedByBarcode = [];
          let detailsWithQC = [];
          rowsDataForToGo.map((detail) => {
            if (detail.idAnagQCOutcome == null) {
              let currentGroup = toGoGroupedByBarcode.find(
                (x) => x.barcode === detail.barcode
              );
              if (currentGroup === undefined || currentGroup === null) {
                var currentDetailsWithQC = [];
                detailsWithQC.map(x => {
                  if (x.barcodeAndCheckDigit == detail.barcodeAndCheckDigit)
                    currentDetailsWithQC.push(x);
                });
                var sumAlreadyQCQty = currentDetailsWithQC.reduce( function(a, b){ return a + b['renderedQty']; }, 0);
                detail.totalRowQty = detail.renderedQty + sumAlreadyQCQty;
                toGoGroupedByBarcode.push(detail);
              } else {
                let qty = currentGroup.renderedQty;
                qty = qty + detail.renderedQty;
                currentGroup.renderedQty = qty;

                let rowQty = currentGroup.totalRowQty;
                rowQty = rowQty + detail.totalRowQty;
                currentGroup.totalRowQty = rowQty;
              }
            } else {
              detailsWithQC.push(detail);
            }
          });

          setToGoDetailsRow(toGoGroupedByBarcode);
          setAllChecked(toGoDetailsRow.length == 0);

          let groupedItems = getControlledGroupData(rowsDataForToControlled);
          setGroupedDetailsRows(groupedItems);
        } else {
          let groupedByBarcodeDetails = [];
          response.data.returnFileRowInfoList.map((detail) => {
            let currentGroup = groupedByBarcodeDetails.find(
              (x) => x.barcode === detail.barcode
            );
            if (currentGroup === undefined || currentGroup === null) {
              groupedByBarcodeDetails.push(detail);
            } else {
              let qty = currentGroup.renderedQty;
              qty = qty + detail.renderedQty;
              currentGroup.renderedQty = qty;

              let rowQty = currentGroup.totalRowQty;
              rowQty = rowQty + detail.totalRowQty;
              currentGroup.totalRowQty = rowQty;
            }
          });

          setToGoDetailsRow(groupedByBarcodeDetails);
          setGroupedDetailsRows([]);
        }
        getOutcomesData({
          outcomes: response.data.outcomes,
          returnFileHeadInfo: response.data.returnFileHeadInfo,
          returnFileRowInfoList: initialRowsData,
        });
        setRender(true);
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
        if (error?.response?.data?.type === "ReturnFileNotReceivedAtWarehouse") {
          navigate(-1);
        }
      });
  };

  const getControlledGroupData = (rowsData) => {
    let groupedItems = [];
    rowsData.forEach((detail) => {
      const { idAnagQCOutcome, boxBarcode, isExtra } = detail;
      let currentGroupOfOutcome = groupedItems.find(
        (x) => x.idAnagQCOutcome == idAnagQCOutcome
      );
      if (
        currentGroupOfOutcome === undefined ||
        currentGroupOfOutcome === null
      ) {
        if (idAnagQCOutcome != null) {
          groupedItems.push({
            idAnagQCOutcome: idAnagQCOutcome,
            boxes: [
              {
                boxBarcode: boxBarcode,
                isExtra: detail.isExtra,
                items: [detail],
              },
            ],
          });
        }
      } else {
        let currentGroupOfBox = currentGroupOfOutcome.boxes.find(
          (x) => x.boxBarcode == boxBarcode
        );
        if (currentGroupOfBox === undefined || currentGroupOfBox === null) {
          currentGroupOfOutcome.boxes.push({
            boxBarcode: boxBarcode,
            isExtra: detail.isExtra,
            items: [detail],
          });
        } else {
          let currentGroupItem = currentGroupOfBox.items.find(
            (x) => x.barcode === detail.barcode
          );
          if (currentGroupItem === undefined || currentGroupItem === null) {
            currentGroupOfBox.items.push(detail);
          } else {
            let qty = currentGroupItem.renderedQty;
            qty = qty + detail.renderedQty;
            currentGroupItem.renderedQty = qty;
          }
        }
      }
    }, {});

    return groupedItems;
  };

  const getDetailsHeaderColumns = () => {
    setDetailsColumns([
      {
        field: "barcode",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>
            {intl.formatMessage({ id: "General.Sku" })}
          </Typography>
        ),
        cellClassName: (params) => {
          return params.row.isCites ? "skuCites" : "";
        },
        renderCell: (params) => {
          return <div>{params.row.barcode + params.row.checkDigit}</div>;
        },
        flex: 1,
        minWidth: 120,
      },
      {
        field: "styleCode",
        headerClassName: "grid-header apeLigthBlueBackground ",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>
            {intl.formatMessage({ id: "General.Model" })}
          </Typography>
        ),
        cellClassName: (params) => {
          return params.row.isCites ? "skuCites" : "";
        },
        flex: 1,
        minWidth: 80,
      },
      {
        field: "fabricCode",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>
            {intl.formatMessage({ id: "General.Part" })}
          </Typography>
        ),
        cellClassName: (params) => {
          return params.row.isCites ? "skuCites" : "";
        },
        flex: 1,
        minWidth: 80,
      },
      {
        field: "colorCode",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>
            {intl.formatMessage({ id: "General.Color" })}
          </Typography>
        ),
        cellClassName: (params) => {
          return params.row.isCites ? "skuCites" : "";
        },
        flex: 1,
        minWidth: 80,
      },
      {
        field: "dropCode",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>
            {intl.formatMessage({ id: "General.Drop" })}
          </Typography>
        ),
        cellClassName: (params) => {
          return params.row.isCites ? "skuCites" : "";
        },
        flex: 1,
        minWidth: 80,
      },
      {
        field: "size",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>
            {intl.formatMessage({ id: "General.Size" })}
          </Typography>
        ),
        cellClassName: (params) => {
          return params.row.isCites ? "skuCites" : "";
        },
        flex: 1,
        minWidth: 80,
      },
      {
        field: "articleDescription",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>
            {intl.formatMessage({ id: "General.Description" })}
          </Typography>
        ),
        cellClassName: (params) => {
          return params.row.isCites ? "skuCites" : "";
        },
        flex: 1,
        minWidth: 400,
      },
      {
        field: "renderedQty",
        headerClassName: "grid-header apeLigthBlueBackground ",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>
            {intl.formatMessage({ id: "General.Peces" })}
          </Typography>
        ),
        cellClassName: (params) => {
          return params.row.isCites ? "skuCites" : "";
        },
        flex: 1,
        minWidth: 80,
        renderCell: (params) => {
          var qtyToBeChecked = `${params.row.renderedQty} ${
            params.row.idAnagQCOutcome == null
              ? "/ " + params.row.totalRowQty
              : ""
          }`;
          return <span>{qtyToBeChecked}</span>;
        },
      },
      {
        field: "actionsGo",
        type: "actions",
        headerClassName: "grid-header apeLigthBlueBackground",
        headerName: "",
        width: 80,
        resizable: false,
        renderCell: (params) => {
          var url = "/QCItem/" + idReturnFileHead + "/" + params.row.idArticle;
          if (
            params.row.boxBarcode !== null &&
            params.row.boxBarcode !== undefined
          ) {
            url =
              "/QCItem/" +
              idReturnFileHead +
              "/" +
              params.row.idArticle +
              "/" +
              params.row.boxBarcode;
          }
          return !params.row.qcActionValid ? (
            <IconButton aria-label="go" size="large" color="primary" disabled>
              <ArrowForwardIosIcon />
            </IconButton>
          ) : (
            <Link
              to={url}
              onClick={(e) =>
                handleEditQCClick(
                  params.row.boxBarcode !== null &&
                    params.row.boxBarcode !== undefined
                )
              }
            >
              <IconButton aria-label="go" size="large" color="primary">
                <ArrowForwardIosIcon />
              </IconButton>
            </Link>
          );
        },
      },
      {
        field: "actionsDelete",
        type: "actions",
        headerClassName: "grid-header apeLigthBlueBackground",
        headerName: "",
        width: 80,
        resizable: false,
        renderCell: (params) => {
          return (
            <IconButton
              aria-label="go"
              size="large"
              color="black"
              onClick={(e) => handleDeleteQCRow(e, params.row)}
              sx={{
                "&.MuiButtonBase-root:hover": {
                  bgcolor: "transparent",
                },
                "&.MuiButtonBase-root": {
                  color: "black",
                },
              }}
            >
              <DeleteForeverIcon />
            </IconButton>
          );
        },
      },
    ]);
  };

  const handleEditQCClick = (isEdit) => {
    if (isEdit) {
      dispatch(
        setIsEdit({
          isEdit: true,
        })
      );
    }
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  useEffect(() => {
    setShowToGo(tabValue === "togo");
    setShowControlled(tabValue === "controlled");
    setShowSummary(tabValue === "summary");

    showTabValueRef.current = tabValue;
  }, [tabValue]);

  const getOutcomesData = (data) => {
    var outcomesInfo = [];
    data.outcomes.map((out) => {
      outcomesInfo.push({
        idAnagOutcome: out.idAnagQCOutcome,
        outcome: out.buttonLabel,
        sequence: out.sequence,
        severity: out.severity,
      });
    });

    outcomesInfo.push({
      idAnagOutcome: null,
      outcome: user.profile.user_language == "it" ? "Da Lavorare" : "To Go",
      sequence: 50,
      severity: null,
    });
    setOutcomesData(outcomesInfo);

    var checkedRows = [];
    var notCheckedRows = [];
    var allRows = [];
    data.returnFileRowInfoList.map((row) => {
      if (row.idAnagQCOutcome == null) {
        notCheckedRows.push(row);
      } else {
        checkedRows.push(row);
      }
      allRows.push(row);
    });

    setCheckedData(checkedRows);
    setNotCheckedData(notCheckedRows);
    setAllData(allRows);
  };

  const handleDeleteQCRow = (e, row) => {
    var message = intl.formatMessage({ id: "QC.ConfirmRowDeletion" });
    if (!window.confirm(message)) {
      return false;
    }
    setLoading(true);
    axios
      .delete("/qualitycheck/boxes/" + row.boxBarcode + "/" + row.idArticle)
      .then((response) => {
        setLoading(false);
        toast.success("Deleted!");
        getDetails();
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const handleBack = () => {
    navigate(`${process.env.PUBLIC_URL}/RASearch`);
  };

  //#region Fire Barcode

  const [firedBarcode, setFiredBarcode] = useState("");

  const partialBarcodeRef = useRef("");
  const barcodeTimeoutRef = useRef(null);

  const tabValueRef = useRef(tabValue);
  useEffect(() => {
    tabValueRef.current = tabValue;
    showTabValueRef.current = tabValue;
  }, [tabValue]);

  const toGoDetailsRowRef = useRef(toGoDetailsRow);
  useEffect(() => {
    toGoDetailsRowRef.current = toGoDetailsRow;
  }, [toGoDetailsRow]);

  const groupedDetailsRowsRef = useRef(groupedDetailsRows);
  useEffect(() => {
    groupedDetailsRowsRef.current = groupedDetailsRows;
  }, [groupedDetailsRows]);

  const detailsRowsRef = useRef(detailsRows);
  useEffect(() => {
    detailsRowsRef.current = detailsRows;
  }, [detailsRows]);

  const handleBarcode = useCallback((e) => {
    if (!window.location.href.includes("QCDetail")) return;

    const hasData =
      (toGoDetailsRowRef.current && toGoDetailsRowRef.current.length > 0) ||
      (groupedDetailsRowsRef.current &&
        groupedDetailsRowsRef.current.length > 0) ||
      (detailsRowsRef.current && detailsRowsRef.current.length > 0);
    if (!hasData) return;

    const isNumber = /^[0-9]$/.test(e.key);
    if (!isNumber) return;

    partialBarcodeRef.current += e.key;

    if (barcodeTimeoutRef.current) {
      clearTimeout(barcodeTimeoutRef.current);
    }

    barcodeTimeoutRef.current = setTimeout(() => {
      const code = partialBarcodeRef.current;

      if (code.length === 10 || code.length === 18) {
        setFiredBarcode(code);
        firedBarcodeAction(code);
      }

      partialBarcodeRef.current = "";
    }, 200);
  }, []);

  useEffect(() => {
    window.addEventListener("keypress", handleBarcode);
    return () => {
      window.removeEventListener("keypress", handleBarcode);
      if (barcodeTimeoutRef.current) clearTimeout(barcodeTimeoutRef.current);
    };
  }, [handleBarcode]);

  const handleSelectBarcode = (e, barcode) => {
    e.preventDefault();
    if (barcode == "") {
      var groupedItems = getControlledGroupData(detailsRows);
      setGroupedDetailsRows(groupedItems);
    } else {
      firedBarcodeAction(barcode);
    }
  };

  const firedBarcodeAction = (barcode) => {
    if (showTabValueRef.current == "togo") {
      var article = toGoDetailsRow.find(
        (x) => x.barcodeAndCheckDigit == barcode
      );
      if (article !== null && article !== undefined) {
        navigate(
          `${process.env.PUBLIC_URL}/QCItem/${idReturnFileHead}/${article.idArticle}`
        );
      } else {
        setLoading(true);
        const params = new URLSearchParams([]);
        params.append("barcode", barcode);
        axios
          .get("/masterdata/Articles", { params })
          .then((response) => {
            setLoading(false);
            if (
              response != null &&
              response != undefined &&
              response.data !== null &&
              response.data !== undefined
            ) {
              navigate(
                `${process.env.PUBLIC_URL}/QCItem/${idReturnFileHead}/${response.data.idArticle}`
              );
            }
          })
          .catch((error) => {
            setLoading(false);
            handleError(error, intl);
          });
      }
    } else if (showTabValueRef.current == "controlled") {
      var articles = [];
      if (barcode.length == 18) {
        articles = detailsRowsRef.current.filter(
          (x) => x.boxBarcode == barcode
        );
      } else {
        articles = detailsRowsRef.current.filter(
          (x) => x.barcodeAndCheckDigit == barcode
        );
      }
      var groupedItems = getControlledGroupData(articles);
      setGroupedDetailsRows(groupedItems);
    } else if (showTabValueRef.current == "summary") {
      return;
    }
  };

  //#endregion

  return (
    <div id="articleBarcodeInput">
      {render ? (
        <div>
          <ReturnFileHeader
            idRFHeadRelated={detailsHeader.idRFHeadRelated}
            idReconditionType={detailsHeader.idReconditionType}
            returnFileKey={detailsHeader.returnFileKey}
            rfDate={detailsHeader.rfDate}
            rfType={detailsHeader.rfType}
            rfState={state?.rfState}
            reconditionTypeDescr={detailsHeader.reconditionTypeDescr}
            ictReference={detailsHeader.ictReference}
            invoiceNumber={detailsHeader.invoiceNumber}
            saprso={detailsHeader.saprso}
            sapInboundDelivery={detailsHeader.sapInboundDelivery}
            totalPieces={detailsHeader.totalPieces}
            idReturnFileHead={idReturnFileHead}
            callBackAftereChangeReconditionType={getDetails}
            withStealthFlow={withStealthFlow}
          />
          <ReturnFileActions
            idReturnFileHead={idReturnFileHead}
            showSKUSearch={false}
            returnFileKey={detailsHeader.returnFileKey}
            rfState={detailsHeader.rfStateCode}
            rfType={detailsHeader.rfTypeCode}
            affinityGroup={detailsHeader.affinityGroup}
          />
          <Grid container mt={1} id="fireArticleBarcode">
            <Grid item lg={3}></Grid>
            <Grid
              item
              xs={9.5}
              sm={8}
              md={6.5}
              lg={6}
              sx={{ bgcolor: "#C0C0C0", borderRadius: "10px" }}
            >
              <Grid container mt={1} mb={1} ml={1} mr={1}>
                <Grid
                  item
                  xs={7.8}
                  sm={7.3}
                  md={7.3}
                  lg={9}
                  sx={{ borderRight: "2px dotted white" }}
                >
                  <CustomInput
                    labelText={intl.formatMessage({
                      id: "QC.SkuUdm",
                    })}
                    type="text"
                    classInput="apeBlueColor"
                    value={firedBarcode}
                    setValue={(e) => {
                      setFiredBarcode(e);
                    }}
                    iconComponent={BarcodeIcon}
                    textCol={3.5}
                    inputCol={8.5}
                  />
                </Grid>
                <Grid
                  item
                  xs={4}
                  sm={4.5}
                  md={4.5}
                  lg={2.8}
                  textAlign={"center"}
                >
                  <Box mt={0.5}>
                    <Button
                      variant="outlined"
                      className={
                        tabValue == "summary" ||
                        detailsHeader?.idReconditionType == null ||
                        detailsHeader?.idReconditionType == undefined ||
                        detailsHeader?.idReconditionType == 0
                          ? "QcDisabledButton"
                          : "QcBlueButton"
                      }
                      sx={{ width: "80%" }}
                      disabled={
                        tabValue == "summary" ||
                        detailsHeader?.idReconditionType == null ||
                        detailsHeader?.idReconditionType == undefined ||
                        detailsHeader?.idReconditionType == 0
                      }
                      onClick={(e) => handleSelectBarcode(e, firedBarcode)}
                    >
                      {intl.formatMessage({ id: "General.Select" })}
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
            <Grid item lg={3}></Grid>
          </Grid>
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            sx={{ mt: 0.5, mb: 0.5 }}
            id="tabs"
          >
            <Tab
              icon={<SearchIcon />}
              label={intl.formatMessage({ id: "QC.ToGo" })}
              value={"togo"}
            />
            <Tab
              icon={<AssignmentTurnedInOutlinedIcon />}
              label={intl.formatMessage({ id: "QC.Controlled" })}
              value={"controlled"}
            />
            <Tab
              icon={<BarChartOutlinedIcon />}
              label={intl.formatMessage({ id: "QC.Summary" })}
              value={"summary"}
            />
          </Tabs>

          {showToGo ? (
            <ToGo
              detailsColumns={detailsColumns}
              detailsRows={toGoDetailsRow}
              tableHeigth={tableHeigth}
              id="rowNumber"
            />
          ) : (
            <div></div>
          )}
          {showControlled ? (
            <Controlled
              detailsColumns={detailsColumns}
              tableHeigth={tableHeigth}
              id="rowNumber"
              groupedDetailsRows={groupedDetailsRows}
              outcomes={outcomes}
              reloadFunction={getDetails}
            />
          ) : (
            <div></div>
          )}
          {showSummary ? (
            <Summary
              outcomesData={outcomesData}
              checkedRows={checkedData}
              notCheckedRows={notCheckedData}
              allRows={allData}
            />
          ) : (
            <div></div>
          )}
        </div>
      ) : (
        ""
      )}
      <Grid container mt={1} spacing={1} id="QCButtons">
        <Grid item xs={6} sm={2} md={1} lg={1}>
          <Button
            variant="outlined"
            className="apeBlueColor"
            fullWidth
            onClick={handleBack}
          >
            {intl.formatMessage({ id: "QC.Back" })}
          </Button>
        </Grid>
        {tabValue !== "summary" && !isMagiUser ? (
          <Grid item xs={6} sm={3} md={2} lg={1.8}>
            <Button
              variant="outlined"
              className="apeBlueColor"
              fullWidth
              onClick={handleClickEndOfCheck}
            >
              {intl.formatMessage({ id: "QC.EndOfCheck" })}
            </Button>
          </Grid>
        ) : (
          ""
        )}
      </Grid>

      <Dialog
        open={openEndOfCheck}
        onClose={(e) => {
          e.preventDefault();
          setOpenEndOfCheck(false);
        }}
        aria-labelledby="endOfCheck-dialog-title"
        aria-describedby="endOfCheck-dialog-description"
      >
        <DialogTitle id="endOfCheck-dialog-title">
          {intl.formatMessage({ id: "General.Warning" })}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="endOfCheck-dialog-description">
            {intl.formatMessage({ id: "QC.NotAllChecked" })}
          </DialogContentText>
          <DialogContentText id="endOfCheck-dialog-description2">
            {intl.formatMessage({ id: "QC.DefinitiveOrIntermediate" })}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={(e) => handleCloseEndOfCheck(e, "intermediate")}>
            {intl.formatMessage({ id: "QC.Intermediate" })}
          </Button>
          <Button
            onClick={(e) => handleCloseEndOfCheck(e, "definitive")}
            autoFocus
          >
            {intl.formatMessage({ id: "QC.Definitive" })}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openConfirmEndOfCheck}
        onClose={(e) => {
          e.preventDefault();
          setOpenConfirmEndOfCheck(false);
        }}
        aria-labelledby="endOfCheck-dialog-title"
        aria-describedby="endOfCheck-dialog-description"
      >
        <DialogTitle>
          {intl.formatMessage({ id: "General.Warning" })}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {intl.formatMessage({ id: "General.ConfirmAction" })}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={(e) => handleCloseEndOfCheck(e, "definitive")}>
            {intl.formatMessage({ id: "General.Yes" })}
          </Button>
          <Button
            onClick={(e) => {
              e.preventDefault();
              setOpenConfirmEndOfCheck(false);
            }}
            autoFocus
          >
            {intl.formatMessage({ id: "General.No" })}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default QCDetail;
